import { T } from '@transifex/react';
import { InlineLoading, Text, Toggle } from '@wfp/ui';
import { Row, Col } from 'react-flexbox-grid';
import { Control, Controller } from 'react-hook-form';
import { NotificationInterface } from '@partnerconnect-monorepo/types/notification/Notification';
import { OptionElement } from '@partnerconnect-monorepo/types/types';
import Select from 'react-select';
import { v4 as uuid } from 'uuid';
import { getNotificationLabel } from '../../../../utils/notifications';
import './NotificationView.scss';
interface NotificationViewProps {
  control: Control<NotificationInterface, any>;
  frequencyOptions: Array<OptionElement>;
  isLoading: boolean;
}

export const NotificationView = ({
  control,
  frequencyOptions,
  isLoading
}: NotificationViewProps) => (
  <Row middle="xs">
    <Col className="notification-checkbox">
      {!isLoading ? (
        <Controller
          control={control}
          name="enabled"
          render={({ field }) => (
            <Toggle
              id={uuid()}
              role="checkbox"
              toggled={field.value}
              onToggle={field.onChange}
              labelA=""
              labelB=""
            />
          )}
        />
      ) : (
        <InlineLoading className="notification-inline-loading" />
      )}
    </Col>
    <Col xs>
      <Controller
        control={control}
        name="code"
        render={({ field }) => (
          <Text className="notification-label">
            {getNotificationLabel(field.value)}
          </Text>
        )}
      />
    </Col>
    <Col xs={4}>
      <Controller
        control={control}
        name="frequency"
        render={({ field }) => (
          <Select
            {...field}
            placeholder={<T _str="Click to select" />}
            className="wfp--react-select-container"
            classNamePrefix="wfp--react-select"
            value={field.value}
            options={frequencyOptions}
            isDisabled={frequencyOptions.length === 1 || isLoading}
            isLoading={isLoading}
          />
        )}
      />
    </Col>
  </Row>
);
